import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FollowButton } from '@periscopes/general/FollowButton';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';

import { Space, Tooltip } from 'antd';
import { useCurrentUser, useFeatureFlag, useGlobalSelect } from '@hooks';

export const BulkFollowButtons: React.FC = () => {
	const { removeSelection, getGlobalSelection, globalSelection } = useGlobalSelect();
	const followableSelection = getGlobalSelection({ excludeTypes: [ SonarObjectType.SalesforceReport ] });
	const followerEnabled = useFeatureFlag(FeatureFlag.Followers);
	const { isReadOnly } = useCurrentUser();
	const { followed, unfollowed } = useUpdateFollowing(followableSelection);

	const handleOnClick = () => {
		removeSelection({ selections: [] });
	};

	if (!followerEnabled || isReadOnly) {
		return null;
	}

	return (
		<Space>
			<FollowButton
				onClick={ handleOnClick }
				sonarObjectIds={ followed }
				type='unfollow' />
			<Tooltip
				open={ followableSelection.length < globalSelection.length ? undefined : false }
				placement='bottom'
				title={ COPY_SPECIFIC.REPORTS_CANNOT_BE_FOLLOWED }>
				<div>
					<FollowButton
						onClick={ handleOnClick }
						sonarObjectIds={ unfollowed }
						type='follow' />
				</div>
			</Tooltip>
		</Space>
	);
};
